export type AccessResult =
  | { status: "allowed" }
  | { status: "pending" }
  | { status: "error"; message: string };

export function classifyAccessResult(data: unknown, error: { message: string } | null): AccessResult {
  if (error) return { status: "error", message: error.message };
  const claim = data as { allowed?: unknown; reason?: unknown } | null;
  if (claim?.allowed === true) return { status: "allowed" };
  if (claim?.allowed === false && claim.reason === "email_not_allowlisted") return { status: "pending" };
  return { status: "error", message: "The access check returned no valid result. Please retry." };
}
